export default {
  vcenter: {
    verticalAlign: 'middle',
  },
  center: {
    verticalAlign: 'middle',
    margin: '0 auto',
    textAlign: 'center',
  },
};
